<template>
    <div class="lovenow">
        <div class="bgin" v-if="isState == 0">
            <span>～准备好开始了么～</span>
            <el-button type="primary" @click="begin">立即开始</el-button>
        </div>
        <div class="box" v-if="isState == 1">
            <div class="images">
                <el-image :src="images[step]"></el-image>
            </div>
            <div class="title">
                <span>{{ answer[step] }}</span>
            </div>
            <div class="buttons">
                <el-button type="danger" @click="miss">超级超级想</el-button>
                <el-button type="primary" @click="setStep" :disabled="isDisabled">{{ buttontitle }}</el-button>
            </div>
        </div>
        <div class="box" v-if="isState == 2">
            <div class="images">
                <el-image :src="image"></el-image>
            </div>
        </div>


    </div>
</template>


<script>
import { Button, Row, Col, Image } from 'element-ui';

export default {

    components: {
        ElButton: Button,
        ElRow: Row,
        ElCol: Col,
        ElImage: Image,
    },
    watch: {
        step(newVal, oldVal) {
            console.log(`count 变化了：${oldVal} -> ${newVal}`);

            if (newVal == 7) {
                this.isDisabled = true
                this.buttontitle = '就是不让你点了'
            }
        }
    },
    data() {
        return {
            audio: null,
            isBgin: true,
            step: 0,
            isState: 0,
            isDisabled: false,
            buttontitle: '一点不想',

            image: require('@/assets/阿狸/7.gif'),

            images: [
                require('@/assets/阿狸/1.gif'),
                require('@/assets/阿狸/2.gif'),
                require('@/assets/阿狸/2.gif'),
                require('@/assets/阿狸/3.gif'),
                require('@/assets/阿狸/3.gif'),
                require('@/assets/阿狸/5.gif'),
                require('@/assets/阿狸/5.gif'),
                require('@/assets/阿狸/6.gif'),
            ],
            answer: [
                '哒哒哒～想我了么？？？？',
                '什么？我不信～',
                '你怎么能点这个按钮呢～',
                '你这样我会伤心的～',
                '没爱了～',
                '快点左边的按钮吧～',
                '点旁边的按钮有惊喜的～',
                '哼！不允许你点右边的，快点左边的～',
            ]
        }
    },
    mounted() {
        document.title = "🩷大亨🩷";
        this.audio = new Audio(require('@/assets/阿狸/music.mp3'));
        this.audio.loop = true;
    },
    methods: {
        begin() {
            // this.step +=1
            this.isState = 1
            this.audio.play().catch(err => {
                console.warn("播放失败，可能需要用户交互", err);
            });
        },
        setStep() {
            this.step += 1;
        },
        miss() {
            this.isState = 2
            console.log('想你了～');
        }
    },
    beforeDestroy() {
        // 组件销毁时停止播放并释放资源
        if (this.audio) {
            this.audio.pause();
            this.audio = null;
        }
    },

}
</script>

<style lang="less" scoped>
.lovenow {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #f3dbdc;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    touch-action: manipulation;
    /* 允许点击，但禁用双指缩放 */
    user-select: none;
    /* 禁止文本选择，防止双击选中文字 */

    .bgin {
        // width: 80%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        span {
            font-weight: bold;
            margin-bottom: 30px;
            color: #fb7272;
        }
    }



    .box {
        width: 100%;
        height: 600px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .title {
            color: #fb7272;
            margin-top: 30px;
            font-weight: bold;
        }

        .images {
            width: 80%;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .buttons {
            margin-top: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
}
</style>